import Vue from 'vue'
import VueRouter from 'vue-router'
import DeviceDetector from "device-detector-js";
import { nanoid } from 'nanoid'
Vue.use(VueRouter)

const routes = [
  {
    path: '',
    redirect:'/index'
  },
  {
    path: '/index',
    component: () => import('@/views/Index.vue'),
  },
  {
    path: '/problem',
    name: 'problem',
    component: () => import('@/views/problem/list.vue'),
  },
  {
    path: '/getBrandByHW',
    name: 'getBrandByHW',
    component: () => import('@/views/brand/getBrandByHW.vue'),
  },
  {
    path: '/getBrandByXV',
    name: 'getBrandByXV',
    component: () => import('@/views/brand/getBrandByXV.vue'),
  },
  {
    path: '/error001',
    name: 'error001',
    component: () => import('@/views/error/error001.vue'),
  },
  {
    path: '/error002',
    name: 'error002',
    component: () => import('@/views/error/error002.vue'),
  },
  {
    path: '/error003',
    name: 'error003',
    component: () => import('@/views/error/error003.vue'),
  },
  {
    path: '/error004',
    name: 'error004',
    component: () => import('@/views/error/error004.vue'),
  },
  {
    path: '/error005',
    name: 'error005',
    component: () => import('@/views/error/error005.vue'),
  },
  {
    path: '/error006',
    name: 'error006',
    component: () => import('@/views/error/error006.vue'),
  },
  {
    path: '/error200',
    name: 'error200',
    component: () => import('@/views/error/error200.vue'),
  },
  {
    path: '/error201',
    name: 'error201',
    component: () => import('@/views/error/error201.vue'),
  },
  {
    path: '/testGetBrandByXV',
    name: 'testGetBrandByXV',
    component: () => import('@/views/test/index.vue'),
  },
  {
    path: '/null',
    redirect:'/error200'
  },

]

const router = new VueRouter({
  mode: 'history',
  // mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // keep-alive 返回缓存页面后记录浏览位置
    if (savedPosition && to.meta.keepAlive) {
      return savedPosition;
    }
    // 异步滚动操作
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ x: 0, y: 1 });
      }, 0);
    });
   },
});
// router.beforeEach((to, from, next) => {
//   // 用于PU，UV 统计
//   if(!Vue.$cookies.get("cuid")){
//     const deviceDetector = new DeviceDetector({
//       skipBotDetection : true,// 爬虫跳过
//     });
//     const userAgent = window.navigator.userAgent.toLowerCase();
//     const device = deviceDetector.parse(userAgent);
//     let cuid = nanoid();
//     Vue.$cookies.setItem("device", JSON.stringify({cuid,...device}));
//     let expiresTime = new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1);
//     Vue.$cookies.set('cuid', nanoid(),expiresTime);
//   }
//   next();
// });
export default router
